// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cnmn-form-popup{background-color:rgba(0,0,0,.5);bottom:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;position:fixed;right:0;top:0;z-index:10000}.cnmn-form-popup,.cnmn-form-popup__container{display:-webkit-box;display:-ms-flexbox;display:flex}.cnmn-form-popup__container{background-color:#fff;border-radius:8px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:10px;padding:20px}", ""]);
// Exports
module.exports = exports;
